import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForRouteSummaryRTFReport } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { RouteSummaryReportRTFSchemaObject } from "../RouteSummaryReportRTFSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';

const screenCode = "ROUTESUMMARYREPORTRTF";

export function RouteSummaryReportRTF(props) {
    const componentRef = useRef();
    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [routeSummaryDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        fromDate: "",
        toDate: ""
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        fromDate: "",
        toDate: ""
    });
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });
    const schema = Joi.object(RouteSummaryReportRTFSchemaObject).options({ allowUnknown: true });
    const initialContentRownames = [
        "collectionPointName", "bagCountFi",
        "fieldGrossAmount", "fieldNetAmount",
        "factoryGrossAmount", "factoryNetAmount",
        "lex", "loex", "percentage"
    ];
    const [contentRowNames, setContentRowNames] = useState([]);
    const [columnNames, setColumnNames] = useState([]);
    const initialColumnNames = [
        "Route Names", "No of Bags", "Gross /Kg", "Net /Kg",
        "Gross /Kg", "Net /Kg", "Gross Variance", "Net Variance", "Net Variance Percentage (%)"
    ];
    const initialCsvHeaders = [
        { label: "Route Name", value: "collectionPointName" },
        { label: "Bag Count", value: "bagCountFi" },
        { label: "Field Gross Amount /Kg", value: "fieldGrossAmount" },
        { label: "Field Net Amount /Kg", value: "fieldNetAmount" },
        { label: "Factory Gross Amount /Kg", value: "factoryGrossAmount" },
        { label: "Factory Net Amount /Kg", value: "factoryNetAmount" },
        { label: "G +/-", value: "lex" },
        { label: "AG +/-", value: "looex" },
        { label: "L /Ex /Kg", value: "loex" },
        { label: "Percentage /%", value: "percentage" }
    ];
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [fullTotalRow, setFullTotalRow] = useState([]);
    const [fieldDeductions, setFieldDeductions] = useState([]);
    const [factoryDedutions, setFactoryDeductions] = useState([]);
    const [csvTotalRow, setCsvTotalRow] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [routeSummaryDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [routeSummaryDetails.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...routeSummaryDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...routeSummaryDetails,
            factoryID: target.value,
            routeID: "0"
        });
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...routeSummaryDetails,
            routeID: target.value,
        });
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...routeSummaryDetails,
            fromDate: target.value,
        });
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...routeSummaryDetails,
            toDate: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, RouteSummaryReportRTFSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWROUTESUMMARYREPORTRTF');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();
        setLeafCollectionDetails({
            ...routeSummaryDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(routeSummaryDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(routeSummaryDetails.factoryID);
        setRoutes(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(true);
        const errorMessages = validate(schema, routeSummaryDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        getSelectedDropdownValuesForReport(routeSummaryDetails);
        const result = await services.getRouteSummaryReportData(routeSummaryDetails);
        var factoryResultData = result.factoryData;
        var fieldResultData = result.feildData;
        var convertedFactoryData = removeFactoryDataDuplicates(factoryResultData);
        var convertedFieldData = removeFieldDataDuplicates(fieldResultData);
        var finalFactoryResult = factoryDataMergeByCollectionPoint(convertedFactoryData.finalresult);
        var finalFieldResult = fieldDataMergeByCollectionPoint(convertedFieldData.finalResult);
        var tableData = mergeFactoryAndFieldData(finalFactoryResult, finalFieldResult);
        var totRecord = {
            collectionPointName: "Total",
            bagCountFi: 0,
            fieldActualGrossAmount: 0,
            fieldGrossAmount: 0,
            fieldNetAmount: 0,
            factoryActualGrossAmount: 0,
            factoryGrossAmount: 0,
            factoryNetAmount: 0,
            looex: 0,
            lex: 0,
            loex: 0,
            grossBalance: 0
        };
        tableData.forEach(value => {
            for (const property in value) {
                if (!isNaN(value[property])) {
                    totRecord[property] = (totRecord[property] === undefined ? 0 : parseFloat(totRecord[property]))
                        + parseFloat(value[property]);
                }
            }
        });
        totRecord.percentage = ((totRecord.loex / totRecord.fieldNetAmount) * 100);
        setCsvTotalRow(totRecord)
        tableData.forEach(x => {
            for (const property in x) {
                if (property !== "collectionPointName" && property !== "bagCountFi") {
                    x[property] = parseFloat(x[property]).toFixed(2);
                    delete x.looex;
                }
            }
        });
        setDynamicHeaders(convertedFactoryData.factoryDeductions, convertedFieldData.fieldDeductions)
        if (tableData.length > 0) {
            setIsTableHide(false);
            setReportData(tableData);
            calculateTotal(tableData);
            createDataTable();
        }
    }

    function setDynamicHeaders(facDeductions, fieDeductions) {
        var copyOfContentRowNames = initialContentRownames.slice();
        var copyOfColumnNames = initialColumnNames.slice();
        var copyOfCsvHeaders = initialCsvHeaders.slice();

        var fieldDeductionsIds = [];
        var fieldDedutionNames = [];
        var factoryDeductionsIds = [];
        var factoryDedutionNames = [];
        var fieldsCsv = [];
        var factoryCsv = [];

        if (fieDeductions.length > 0 && facDeductions.length > 0) {
            fieDeductions.forEach(x => {
                fieldDeductionsIds.push(x.id);
                fieldDedutionNames.push(x.name === "Container Deduction" ? "Bag" : x.name);
                fieldsCsv.push({ label: x.name, value: x.id });
            });

            facDeductions.forEach(x => {
                factoryDeductionsIds.push(x.id);
                factoryDedutionNames.push(x.name === "Container Deduction" ? "Bag" : x.name);
                factoryCsv.push({ label: x.name, value: x.id });
            });

            copyOfContentRowNames.splice(3, 0, ...fieldDeductionsIds);
            copyOfContentRowNames.splice(5 + factoryDeductionsIds.length, 0, ...factoryDeductionsIds);

            copyOfColumnNames.splice(3, 0, ...fieldDedutionNames);
            copyOfColumnNames.splice(5 + factoryDedutionNames.length, 0, ...factoryDedutionNames);

            copyOfCsvHeaders.splice(3, 0, ...fieldsCsv);
            copyOfCsvHeaders.splice(5 + fieldsCsv.length, 0, ...factoryCsv);

            setColumnNames(copyOfColumnNames);
            setContentRowNames(copyOfContentRowNames);
            setCsvHeaders(copyOfCsvHeaders);
        }
    }

    function mergeFactoryAndFieldData(factoryData, FieldData) {
        var merged = _.merge(_.keyBy(factoryData, 'collectionPointID'), _.keyBy(FieldData, 'collectionPointID'));
        var values = _.values(merged);

        values.forEach(x => {
            for (const property in x) {
                if (property !== "collectionPointName" && property !== "bagCountFi") {
                    x[property] = parseFloat(x[property]).toFixed(2);
                }
            }
            var facNet = x.factoryNetAmount === undefined ? 0 : x.factoryNetAmount;
            var fiNet = x.fieldNetAmount === undefined ? 0 : x.fieldNetAmount;
            var facGross = x.factoryGrossAmount === undefined ? 0 : x.factoryGrossAmount;
            var fiGross = x.fieldGrossAmount === undefined ? 0 : x.fieldGrossAmount;
            var fiaGross = x.fieldActualGrossAmount === undefined ? 0 : x.fieldActualGrossAmount;
            var facaGross = x.factoryActualGrossAmount === undefined ? 0 : x.factoryActualGrossAmount;

            x.lex = parseFloat(facGross - fiGross).toFixed(2);
            x.loex = parseFloat(facNet - fiNet).toFixed(2);
            x.loexx = parseFloat(fiaGross - fiGross).toFixed(2);
            x.looex = parseFloat(facaGross - fiaGross).toFixed(2);
            x.grossBalance = parseFloat(facaGross - facGross).toFixed(2);
            x.percentage = ((((x.loex / facNet) * 100) == Infinity) || (((x.loex / facNet) * 100) == -Infinity) || (((x.loex / facNet) * 100) == NaN)) ? 0 : parseFloat((x.loex / facNet) * 100).toFixed(2);
        });
        return values;
    }

    function removeFactoryDataDuplicates(data) {
        var result = [];
        var deductionArray = [];
        var complexResult;
        data.forEach(x => {
            if (result.length === 0) {
                result.push({
                    factoryGrossAmount: x.factoryGrossAmount,
                    factoryNetAmount: x.factoryNetAmount,
                    [x.deductionTypeID + "Fa"]: (x.factoryDeductionAmount),
                    factoryWeighDetailID: x.factoryWeighDetailID,
                    collectionPointID: x.collectionPointID,
                    collectionPointName: x.collectionPointName,
                    factoryActualGrossAmount: x.actualAmount,
                    bagCount: x.bagCount
                });
                deductionArray.push({ id: x.deductionTypeID + "Fa", name: x.deductionTypeName });
            } else {
                var selectedFactoryItem = result.find(y => y.collectionPointID === x.collectionPointID);
                if (!selectedFactoryItem) {
                    result.push({
                        factoryGrossAmount: x.factoryGrossAmount,
                        factoryNetAmount: x.factoryNetAmount,
                        [x.deductionTypeID + "Fa"]: (x.factoryDeductionAmount),
                        factoryWeighDetailID: x.factoryWeighDetailID,
                        collectionPointID: x.collectionPointID,
                        collectionPointName: x.collectionPointName,
                        factoryActualGrossAmount: x.actualAmount,
                        bagCount: x.bagCount
                    });
                    deductionArray.push({ id: x.deductionTypeID + "Fa", name: x.deductionTypeName });
                } else {
                    selectedFactoryItem[x.deductionTypeID + "Fa"] = (x.factoryDeductionAmount);
                    deductionArray.push({ id: x.deductionTypeID + "Fa", name: x.deductionTypeName });
                }
            }
        });
        var uniqDeductions = deductionArray.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
        setFactoryDeductions(uniqDeductions);
        complexResult = {
            finalresult: result,
            factoryDeductions: uniqDeductions
        }
        return complexResult;
    }

    function factoryDataMergeByCollectionPoint(data) {
        var mergedFactoryDataResult = [];
        var grouped = _.groupBy(data, a => {
            return a.collectionPointID;
        });
        for (let [key, value] of Object.entries(grouped)) {
            var tempRecord = {};
            var bagCount = value.length;
            value.forEach(x => {
                for (let [k, v] of Object.entries(x)) {
                    if (k !== "collectionPointID" && k !== "factoryWeighDetailID" && k !== "collectionPointName") {
                        if (!isNaN(k)) {
                            tempRecord[k + "Fa"] = (tempRecord[k + "Fa"] === undefined) ? (v)
                                : (tempRecord[k + "Fa"] + v);
                        } else {
                            tempRecord[k] = (tempRecord[k] === undefined) ? (v)
                                : (tempRecord[k] + v);
                        }
                    } else if (k === "collectionPointID") {
                        tempRecord.collectionPointID = v;
                    } else if (k === "collectionPointName") {
                        tempRecord.collectionPointName = v;
                    }
                }
            });
            tempRecord.bagCountFa = bagCount;
            mergedFactoryDataResult.push(tempRecord);
        }
        return mergedFactoryDataResult;
    }

    function removeFieldDataDuplicates(data) {
        var result = [];
        var deductionArray = [];
        var complexResult;
        data.forEach(x => {
            if (result.length === 0) {
                result.push({
                    fieldGrossAmount: x.fieldGrossAmount,
                    fieldNetAmount: x.fieldNetAmount,
                    [x.deductionTypeID + "Fi"]: (x.fieldDeductionAmount),
                    productCollectionDetailsID: x.productCollectionDetailsID,
                    collectionPointID: x.collectionPointID,
                    collectionPointName: x.collectionPointName,
                    fieldActualGrossAmount: x.actualAmount,
                    bagCount: x.bagCount
                });
                deductionArray.push({ id: x.deductionTypeID + "Fi", name: x.deductionTypeName });
            } else {
                var selectedFactoryItem = result.find(y => y.collectionPointID === x.collectionPointID);

                if (!selectedFactoryItem) {
                    result.push({
                        fieldGrossAmount: x.fieldGrossAmount,
                        fieldNetAmount: x.fieldNetAmount,
                        [x.deductionTypeID + "Fi"]: (x.fieldDeductionAmount),
                        productCollectionDetailsID: x.productCollectionDetailsID,
                        collectionPointID: x.collectionPointID,
                        collectionPointName: x.collectionPointName,
                        fieldActualGrossAmount: x.actualAmount,
                        bagCount: x.bagCount
                    });
                    deductionArray.push({ id: x.deductionTypeID + "Fi", name: x.deductionTypeName });
                } else {
                    selectedFactoryItem[x.deductionTypeID + "Fi"] = (x.fieldDeductionAmount);
                    deductionArray.push({ id: x.deductionTypeID + "Fi", name: x.deductionTypeName });
                }
            }
        });

        var uniqDeductions = deductionArray.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
        setFieldDeductions(uniqDeductions);
        complexResult = {
            finalResult: result,
            fieldDeductions: uniqDeductions
        }
        return complexResult;
    }

    function fieldDataMergeByCollectionPoint(data) {
        var mergedFieldDataResult = [];
        var grouped = _.groupBy(data, a => {
            return a.collectionPointID;
        });
        for (let [key, value] of Object.entries(grouped)) {
            var tempRecord = {};
            var bagCount = value[0].bagCount;
            value.forEach(x => {
                for (let [k, v] of Object.entries(x)) {
                    if (k !== "collectionPointID" && k !== "productCollectionDetailsID" && k !== "collectionPointName") {
                        if (!isNaN(k)) {
                            tempRecord[k + "Fi"] = (tempRecord[k + "Fi"] === undefined) ? (v)
                                : (tempRecord[k + "Fi"] + v);
                        } else {
                            tempRecord[k] = (tempRecord[k] === undefined) ? (v)
                                : (tempRecord[k] + v);
                        }
                    } else if (k === "collectionPointID") {
                        tempRecord.collectionPointID = v;
                    } else if (k === "collectionPointName") {
                        tempRecord.collectionPointName = v;
                    }
                }
            });
            tempRecord.bagCountFi = bagCount;
            mergedFieldDataResult.push(tempRecord);
        }
        return mergedFieldDataResult;
    }

    function calculateTotal(data) {
        var total = [];
        data.forEach(x => {
            for (var property in x) {
                if (property !== "collectionPointName") {
                    total.push({ name: property, value: x[property] });
                }
            }
        });
        const res = Array.from(total.reduce(
            (m, { name, value }) => m.set(name, parseFloat(m.get(name) || 0) + parseFloat(value)), new Map
        ), ([name, value]) => ({ name, value }));
        setFullTotalRow(res);
        return res;
    }

    function createDataTable() {
        $("#leafCollectionSummary").DataTable()
    }

    function createFile() {
        var settings = {
            sheetName: 'Route Summary Report',
            fileName: 'RouteSummaryReportRTF',
            writeOptions: {}
        };
        var copyOfCsv = _.cloneDeep(reportData)
        copyOfCsv.push(csvTotalRow)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...routeSummaryDetails,
            routeID: "0",
            fromDate: "",
            toDate: ""
        });
        setIsTableHide(true);
        setErrors("");
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Route Summary Report RTF"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={routeSummaryDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={routeSummaryDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={routeSummaryDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, routeSummaryDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="leafCollectionSummary" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th colSpan="2"></th>
                                                            <th colSpan={2 + fieldDeductions.length} style={{ textAlign: "center" }}>Field Weight /Kg</th>
                                                            <th colSpan={2 + factoryDedutions.length} style={{ textAlign: "center" }}>Factory Weight /Kg</th>
                                                            <th></th>
                                                            <th></th>
                                                        </tr>
                                                        <tr>
                                                            {columnNames.map((x, index) => (
                                                                <th key={index}>{x}</th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForRouteSummaryRTFReport
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th>Total</th>
                                                            {contentRowNames.map((name, index) => {
                                                                let res = fullTotalRow.find(item => item.name === name);
                                                                if (res) {
                                                                    return (
                                                                        <th key={index} style={{ textAlign: "right" }}>
                                                                            {res.value.toFixed(2)}
                                                                        </th>
                                                                    );
                                                                }
                                                            })}
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pt-4">
                                        {/* <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        /> */}
                                        <ReactToPrint
                                            documentTitle={"Route Summary Report RTF"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} columnNames={columnNames} fieldDeductions={fieldDeductions}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} factoryDedutions={factoryDedutions} fullTotalRow={fullTotalRow} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
